import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import moment from "moment";
import { icon, timeSince } from "./notificationFunctions";
import { FaCircle } from "react-icons/fa";

import "./notificationBox.css";
import useSessionData from "../../../hooks/useSessionData";

const NotificationData = () => {
  const notificationDivRef = useRef(null);
  const [notificationData, setnotificationData] = useState([]);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const sessionList = useSelector((state) => state.sessionData.sessionScope);
  // const { sessionList } = useSessionData();

  useEffect(() => {
    if (sessionList?.userId) {
      getNotificationData();
    }
  }, [sessionList]);

  const getNotificationData = async () => {
    await axios
      .get(
        `/user/${sessionList?.userId}/notifications?offset=${count}&limit=10`
      )
      .then((response) => {
        setnotificationData([...notificationData, ...response.data]);
        if (response.data.length > 0) {
          setHasMore(true);
          setCount(count + response.data.length);
        } else {
          setHasMore(false);
        }
      });
  };

  const renderComponentByKey = (key) => {
    if (icon.hasOwnProperty(key)) {
      return icon[key];
    }
    return icon["Others"];
  };

  return (
    <>
      <div
        id="notification-body"
        style={{
          height: 300,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <InfiniteScroll
          dataLength={notificationData.length}
          next={getNotificationData}
          onScroll={() => {}}
          style={{ display: "flex", flexDirection: "column" }}
          inverse={false} //
          hasMore={hasMore}
          loader={<div>Loading ...</div>}
          endMessage={<b className="mt-3">You have seen it all</b>}
          scrollableTarget="notification-body"
        >
          {notificationData &&
            notificationData.map((item, index) => (
              <div
                key={index}
                className={
                  item.read == true
                    ? "card dropdown-item notification-card notification-invitation d-flex align-items-center px-0 testclass"
                    : "card dropdown-item notification-card notification-invitation d-flex align-items-center px-0"
                }
                onclick="readnotification(this)"
                datatype={item.type}
                datacontactid={item.referenceId}
                dataid={item.notificationId}
                dataurl={item.notificationUrl}
                style={{
                  width: "500px",
                  minHeight: "70px",
                  backgroundColor: !item.read && "#eaeff2",
                }}
              >
                <div className="card-body px-0 w-100 py-0 d-flex flex-row align-items-center">
                  <div className="col-1">{renderComponentByKey(item.type)}</div>
                  <div className="col-9">
                    <div
                      className="card-title mb-0"
                      style={{ whiteSpace: "break-spaces" }}
                      dangerouslySetInnerHTML={{
                        __html: item.notificationDescription,
                      }}
                    ></div>
                    <div className="cardDate" style={{ fontSize: "10px" }}>
                      {item.createdOn
                        ? moment(item.createdOn).format("D MMM YYYY, h:mm:s a")
                        : "Date"}
                    </div>
                  </div>
                  <div className="col-2 d-flex flex-row justify-content-center align-items-center">
                    <div className="cardHours col-11 px-0">
                      {" "}
                      {item.createdOn ? timeSince(item.createdOn) : "Time"}{" "}
                    </div>
                    <div className="col-2 px-0">
                      <FaCircle />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </InfiniteScroll>
      </div>
    </>
  );
};

export default NotificationData;
